import React from 'react';

import { ActionIcon, Group, Menu, px, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDotsVertical } from '@tabler/icons-react';
import { KiloClassCoachRole } from 'types';

import ModalDeleteClassCoachRole from './ModalDeleteClassCoachRole';
import ModalEditClassCoachRole from './ModalEditClassCoachRole';

interface IClassCoachRoleTableHeaderProps {
  permission?: boolean;
  role: KiloClassCoachRole;
}

const ClassCoachRoleTableHeader = ({
  role,
  permission = true,
}: IClassCoachRoleTableHeaderProps): JSX.Element => {
  const theme = useMantineTheme();
  const [editModalOpened, { open: openEditModal, close: clodeEditModal }] = useDisclosure(false);
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);

  return (
    <th
      key={role.kiloClassCoachRoleId}
      style={{ width: `${px(theme.spacing.xl) * 10}px`, background: theme.colors.gray[1] }}
    >
      <Group position='apart'>
        {role.name}
        <Menu position='bottom-end'>
          <Menu.Target>
            <ActionIcon
              data-cy='actionClassCoachRoleButton'
              variant='subtle'
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
              disabled={!permission}
            >
              <IconDotsVertical size={theme.fontSizes.md} fill={theme.white} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={openEditModal}>Edit</Menu.Item>
            <Menu.Item onClick={openDeleteModal}>Delete</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <ModalEditClassCoachRole opened={editModalOpened} handleClose={clodeEditModal} classCoachRole={role} />
      <ModalDeleteClassCoachRole
        opened={deleteModalOpened}
        handleClose={closeDeleteModal}
        kiloClassCoachRoleId={role.kiloClassCoachRoleId}
      />
    </th>
  );
};

export default ClassCoachRoleTableHeader;
